import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Alert from '@material-ui/lab/Alert';
import PasswordToggle from 'components/PasswordToggle';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
  },
  input: {
    backgroundColor: theme.palette.common.paleGrey,
  },
}));

const AuthField = ({onChange, onEnter, error, type, ...props}) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';

  const onKeyUp = (event) => {
    if (event.keyCode === 13 && onEnter) {
      onEnter();
    }
  };

  const handleOnClick = () => setShowPassword(!showPassword);

  return (
    <FormControl className={classes.formControl}>
      <div className={classes.holder}>
        <TextField
          fullWidth
          variant="outlined"
          type={isPassword && showPassword ? 'text' : type}
          onChange={(event) => onChange && onChange(event.target.value)}
          error={error !== undefined}
          onKeyUp={onEnter ? onKeyUp : undefined}
          {...props}
          InputProps={{
            className: classes.input,
            endAdornment: isPassword
              ? <PasswordToggle showPassword={showPassword} onClick={handleOnClick} />
              : undefined,
          }}
        />
        {error && <Alert severity="error">{error}</Alert>}
      </div>
    </FormControl>
  );
};

AuthField.propTypes = {
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  error: PropTypes.string,
  type: PropTypes.string,
};

export default AuthField;
